
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  noIssue = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  emits: ["close", "submit"],
  components: {}
})
export default class ModalSuccesFinish extends Vue.with(Props) {
  onSubmitModal() {
    this.$emit("update:modelValue", false);
    this.$emit("submit");
    this.$router.push("/pusat-resolusi-v2");
    this.$toast.add({
      severity: "success",
      detail: `<div>${this.$t("pusatResolusi.success.toastSuccess", {
        noIssue: this.noIssue
      })}</div>`,
      life: 10000,
      closable: false,
      icon: "success-status"
    });
  }
}
